const loadMoreFaqs = btn => {
    const overlay = document.querySelector('.loading-overlay');
    const itemsArr = [];
    const itemsWrapper = document.querySelector('.tr-faq-filters__faq-posts-wrapper');
    const items = itemsWrapper.querySelectorAll('.tjc-acc-item');

    items.forEach(item => {
        itemsArr.push(item.getAttribute('data-post-id'));
    });
    const sectionId = btn.getAttribute('data-cat-id');
    const postsToLoad = btn.getAttribute('data-posts-count');
    const totalPosts = btn.getAttribute('data-total-posts');

    let data = {
        action: "tr_ajax_load_more_faqs",
        posts: itemsArr,
        catId: sectionId,
        postsToLoad: postsToLoad,
    };

    $.ajax({
        url: themeVars.ajaxurl,
        data: data,
        type: "POST",

        beforeSend: function () {
            overlay.classList.add('active');
            btn.classList.add('disabled');
        },

        success: function (data) {
            if (data) {
                itemsWrapper.insertAdjacentHTML('beforeend', data);
                overlay.classList.remove('active');
                btn.classList.remove('disabled');
                itemsWrapper.querySelectorAll('.tjc-acc-item').length >= totalPosts ? btn.style.display = 'none' : '';
            }
        },
    });
};
export default loadMoreFaqs;
